// extracted by mini-css-extract-plugin
export default {"tabButton":"BottomTabButton_tabButton__e77aQ","tabButtonActive":"BottomTabButton_tabButtonActive__BiYR-","tabButtonText":"BottomTabButton_tabButtonText__BsEhL"};